import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import store from '@/store'

const InvoicesTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/invoices`,
  rowsPath: 'invoices',
  rowClickable: true,
  attachPageId: false,
  columns: [
    {
      label: 'page.name',
      field: 'page',
    },
    {
      label: 'invoice.cost',
      field: 'cost',
    },
    {
      label: 'invoice.commission',
      field: 'commission',
      hidden: store.getters['auth/isClient'],
    },
    {
      label: 'invoice.discount',
      field: 'discount',
      hidden: !store.getters['auth/isAdmin'],
    },
    {
      label: 'invoice.bya3com',
      field: 'bya3com',
      hidden: store.getters['auth/isClient'],
    },
    {
      label: 'invoice.subscribed-at',
      field: 'subscribed_at',
    },
    {
      label: 'invoice.expires-at',
      field: 'expires_at',
    },
    {
      label: 'invoice.paid',
      field: 'paid',
    },
    {
      label: 'page.package-name',
      field: 'package',
    },
    {
      label: 'invoice.period',
      field: 'period',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
    {
      label: 'invoice.paid',
      query: 'paid',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.yes', value: 1 }, { text: 'general.no', value: 0 }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
  ],
}

export default InvoicesTableConfig
